module.exports = __webpack_public_path__ + "a01303be0e52032b56ab8385e8e3d34f.svg";